<template>
    <div>
        <el-checkbox 
            v-model="checkAll" 
            @change="handleCheckAllChange"
            v-if="isAll" style="display:inline-block;margin-left:0;margin-right:10px;">{{title}}
        </el-checkbox>
        <!--<div style="margin: 15px 0;"></div>-->
        <el-checkbox-group 
            v-model="checkedList" 
            @change="handleCheckedChange"
            :size="size"
            :fill="fill"
            :textColor="textColor"
            :min="min"
            :max="max" style="display:inline-block;margin-left:0;margin-right:10px;">
            <el-checkbox 
                v-for="(item, i) in dataList" 
                :label="item.id" 
                :key="i"
                style="display:inline-block;margin-left:0;margin-right:15px;">{{item.name}}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>
<script>
    /**
     * 基于element-ui的Checkbox封装，将需要参数配置封装 使用v-model直接绑定 
     * 复选框组件
     * @author wxf
     * @time 2017-09-19
     *
     * 【Checkbox Attributes】
     * @param isIndeterminate 【description: 设置 indeterminate 状态，只负责样式控制】
     * @param disabled 【description: 按钮禁用】
     * @param isAll 【description: 当前是否具有全选框】
     * @param title 【全选显示文本 默认为全部】 update wxq 2018.7.10
     * 【Checkbox-group Attributes】
     * @param size 【description: Checkbox 按钮组尺寸，large, small】
     * @param fill 【description: 按钮激活时的填充色和边框色】
     * @param text-color 【description: 按钮激活时的文本颜色】
     * @param min 【description: 可被勾选的 checkbox 的最小数量】
     * @param max 【description: 可被勾选的 checkbox 的最大数量】
     * @events change 【description: 当绑定值变化时触发的事件，回调参数：event 事件对象】
     *
     * @param dataList 【description: 外部传入数组，结构只能类似: data:[{id:xxx,name:xxx}...]】
     * @param value 【description: 类似双向绑定的值，个人理解】
     * @param defaultCheck 【description: 默认选项，"all" 或者 数组】
     * @param returnAll 【description: 如果是全选，返回["all"]】
     * @param type 【description: 区分传统checkbox，1：传统，2是自定义，如果需要默认显示，type必须为2】
     */
    export default {
        name: 'LyCheckbox',
        props: {
            title: {
                type: String,
                default: '全部'
            },
            dataList: Array,
            value: {
                type: Array,
                default: () => []
            },
            defaultCheck: [Array,String],
            disabled: {
                type: Boolean,
                default: false
            },
            isAll: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#20a0ff'
            },
            textColor: {
                type: String,
                default: '#ffffff'
            },
            min: Number,
            max: Number,
            returnAll: {
                type: Boolean,
                default: false
            },
            type: {
                type: Number,
                default: 1
            },
            checkedChange: {
                type: Function,
                default: function () {}
            }
        },
        data () {
            return {
                checkAll: false,
                checkedList: [], // 已选项
                dataIds: [] // 全选时的已选项
            }
        },
        created () {
            // 有时候会出现在这里dataList没有数据的情况
            this.dataIds = this.dataList.map((item) => {
                return item.id
            })
            // 全选配置
            if (this.defaultCheck === 'all') {
                this.checkAll = true
            } else { // 调整默认值显示 modify 2018-5-16 by wxf 
                if (this.defaultCheck) {
                    this.checkedList = this.defaultCheck.map((item) => {
                        return item
                    })
                }
            }
            if (this.checkAll) {
                this.checkedList = this.dataIds
            } 
            if (this.type === 1) {
                this.refValue()
            }     
        },
        watch: {
            value (v) {
                if (this.type === 1) {
                    this.refValue()
                }   
            },
            checkAll (v) {
                if (v) {
                    var list = this.dataList.map((item) => {
                        return item.id
                    }) // 全部选项
                    this.checkedList = this.dataIds.length === this.dataList.length ? this.dataIds : list // 在dataIds没值的情况下，直接获取整个选项的数据
                }
            },
            checkedList (v) {
                // console.log("v",v)
                this.$emit('input', v)
            },
            // dataList (v) {
            //     console.log("datalist:%O",v)
            // }
        },
        methods: {
            /**
            * 全选监听
            * @param checked 更新后的值
            */
            handleCheckAllChange (checked) {
                var list = this.dataList.map((item) => {
                    return item.id
                })
                this.checkedList = checked ? (this.dataIds.length > 0 ? this.dataIds : list) : [] // 在dataIds没值的情况下，直接获取整个选项的数据
            },
            /**
            * 单选监听
            */
            handleCheckedChange (value) {
                let checkedCount = value.length
                this.checkAll = checkedCount === this.dataList.length
            },
            /**
             * 如果值不统一，手动覆盖以保持一致
             */
            refValue () {
                if (this.value !== this.checkedList) {
                    this.checkedList = this.value
                }
            },
        }
    }
</script>